// extracted by mini-css-extract-plugin
export default {"buttons":"eHOBOc","button":"K5MgMD","root":"BGJedN"};